/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Social_Google_TimeoutInputs */

const en_auth_social_google_timeout = /** @type {(inputs: Auth_Social_Google_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google took too long to respond. Please try again.`)
};

const es_auth_social_google_timeout = /** @type {(inputs: Auth_Social_Google_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google tardo demasiado en responder. Intentalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Google took too long to respond. Please try again." |
*
* @param {Auth_Social_Google_TimeoutInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_social_google_timeout = /** @type {((inputs?: Auth_Social_Google_TimeoutInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Social_Google_TimeoutInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_social_google_timeout(inputs)
	return es_auth_social_google_timeout(inputs)
});